import Slider from 'javascripts/globals/slider';

const classes = {
  sliderFrame: 'profile-slider__slider-items',
  sliderItem: 'profile-slider__slider-item',
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-profile-slider').forEach(($profileSlider) => {
    const newProfileSlider = new Slider($profileSlider, classes);

    // Toggle aria-current and thus style of navbar
    function toggleNavlinks(scrollIndex) {
      // Re-set aria-currents to false
      $profileSlider
        .querySelectorAll('.profile-slider__list-link')
        .forEach(($link) => {
          const linkIndex = $link.getAttribute('data-uid');
          const parsedIndex = parseInt(linkIndex, 10);

          // Set aria-current if visible index has changed
          if (parsedIndex === scrollIndex) {
            $link.setAttribute('aria-current', 'true');
          } else {
            $link.setAttribute('aria-current', 'false');
          }
        });

      // Set aria-current to true, scroll to slide via index on clicked link
      const { event } = window;
      const $navLinkIndex = event.target.getAttribute('data-uid');
      const $ariaState = event.target.getAttribute('aria-current');

      if ($ariaState === 'false') {
        event.target.setAttribute('aria-current', 'true');
        newProfileSlider.scrollToSlide($navLinkIndex);
      }
    }

    /** @param {Event} event  */
    function navLinkDoubleClick(event) {
      const { target } = event;
      const { uid } = target.dataset;

      if (uid) {
        const $targetSlide = $profileSlider.querySelectorAll(`.${classes.sliderItem}`)[uid];
        const $targetLink = $targetSlide.querySelector('[href]');

        if ($targetLink) {
          $targetLink.click();
        }
      }
    }

    // Set aria-current and style of navbar on load
    function initNavlinks() {
      $profileSlider
        .querySelectorAll('.profile-slider__list-link')
        .forEach(($link, $index) => {
          $link.addEventListener('click', toggleNavlinks);
          $link.addEventListener('dblclick', navLinkDoubleClick);

          if ($index === 0) {
            $link.setAttribute('aria-current', 'true');
          }
        });
    }

    // Hide Navbar if there is only one item, otherwise init Navbar and scroll listener
    if (newProfileSlider.$sliderItems.length < 2) {
      $profileSlider.querySelector('.profile-slider__navbar').style.display = 'none'; // eslint-disable-line
    } else {
      initNavlinks();

      // Watch scroll changes
      newProfileSlider.$sliderFrame.addEventListener('scroll', () => {
        // Get index number of the most visible slide
        const visibleSlideIndex = Math.round(
          newProfileSlider.$sliderFrame.scrollLeft / newProfileSlider.$sliderFrame.clientWidth,
        );

        // Toogle aria-current with new index
        toggleNavlinks(visibleSlideIndex);
      }, { passive: true });
    }
  });
});
